/* ==============================
   GLOBAL SHARED STATE (IMPORTANT)
============================== */
let header = null;
let heroIsVisible = false;
let heroObserver = null;

/* ==============================
   HERO OBSERVER CONTROLS
============================== */
function stopHeroObserver() {
  if (heroObserver) {
    heroObserver.disconnect();
    heroObserver = null;
  }
}

function startHeroObserver(heroSection) {
  if (!heroSection || !header) return;

  stopHeroObserver();

  heroObserver = new IntersectionObserver(
    ([entry]) => {
      heroIsVisible = entry.isIntersecting;
      header.classList.toggle("in-hero", heroIsVisible);
    },
    { threshold: 0.6 }
  );

  heroObserver.observe(heroSection);
}

/* ----------------------------- LENIS SMOOTH SCROLL ----------------------------- */
const lenis = new Lenis({
  smoothWheel: true,
  smoothTouch: false,
  normalizeWheel: true,
  ignore: el => el.classList.contains("scroll-section")
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add(time => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);

/* ----------------------------- SIZE GUIDE ----------------------------- */
/* OPEN ALL MATCHING SIZE BOXES */
window.openSizeBox = () => {
  document.querySelectorAll(".size-2-body-container").forEach(el => {
    el.classList.add("up");
  });
};

/* CLOSE ALL MATCHING SIZE BOXES */
window.removeGuide = () => {
  document.querySelectorAll(".size-2-body-container").forEach(el => {
    el.classList.remove("up");
  });
};

/* SWITCH SIZE GUIDE TABS */
window.showSizeGuide = (id, clickedEl) => {
  const parent = clickedEl.closest(".size-2-body-container");

  if (!parent) return;

  parent.querySelectorAll(".size2-option").forEach(t => t.classList.remove("active"));
  parent.querySelectorAll(".chart-container").forEach(c => c.classList.remove("active"));

  clickedEl.classList.add("active");
  parent.querySelector(`#${id}`)?.classList.add("active");
};


/* CLOSE WHEN CLICKING OUTSIDE */
document.querySelectorAll('.size-2-guide-container').forEach(container => {
  container.addEventListener('click', function(e) {

    // if clicked on overlay/background only
    if (e.target === container) {
      container.closest('.size-2-body-container')?.classList.remove('up');
    }

  });
});

/* ----------------------------- SWIPER ----------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Swiper === "undefined") return;
  if (!document.querySelector(".swiper-container")) return;

  new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });
});

/* ----------------------------- HEADER LOGIC ----------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".evemen-header");
  const heroSection =
    document.querySelector(".evemen-hero_section") ||
    document.querySelector(".daily-hero");

  const bannerSection = document.querySelector(".evemen-c-banner-container");

  if (!header) return;

  let heroIsVisible = false;

  /* ================= HERO OBSERVER ================= */
  if (heroSection && "IntersectionObserver" in window) {
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        heroIsVisible = entry.isIntersecting;
        header.classList.toggle("in-hero", heroIsVisible);
      },
      {
        threshold: 0.6
      }
    );

    heroObserver.observe(heroSection);
  }

  /* ================= SCROLL FALLBACK ================= */
  if (bannerSection) {
    window.addEventListener(
      "scroll",
      () => {
        if (heroIsVisible) return;

        const passed = bannerSection.getBoundingClientRect().top <= 20;
        header.classList.toggle("in-hero", passed);
      },
      { passive: true }
    );
  }
});


/* ---------------------- MENU TOGGLE LOGIC ---------------------- */
document.addEventListener("DOMContentLoaded", () => {

  /* ---------- CACHE HEADER ---------- */
  header = document.querySelector(".evemen-header");
  if (!header) {
    console.warn("evemen-header not found");
    return;
  }

  /* ---------- MENU TOGGLE ---------- */
  const menuTrigger = document.querySelector(".line-box");
  const menuDataBox = document.querySelector(".header-menu-data-box");

  if (!menuTrigger || !menuDataBox) {
    console.warn("Menu trigger or menu box missing");
    return;
  }

  menuTrigger.addEventListener("click", function (e) {
    e.preventDefault();

    const spans = this.querySelectorAll("span");
    const [s0, s1, s2] = spans;
    const isActive = menuDataBox.classList.contains("active");

    /* ================= OPEN MENU ================= */
    if (!isActive) {
      if (typeof stopHeroObserver === "function") {
        stopHeroObserver();
      }

      header.classList.remove("in-hero");

      if (s0) s0.style.transform = "rotate(45deg) translate(4px,4px)";
      if (s2) s2.style.transform = "rotate(-45deg) translate(5px,-5px)";
      if (s1) s1.classList.add("hidden_spn");

      menuDataBox.classList.add("active");
      document.body.classList.add("menu-open");
    }

    /* ================= CLOSE MENU ================= */
    else {
      if (typeof startHeroObserver === "function") {
        const hero = document.querySelector(".evemen-hero_section");
        if (hero) startHeroObserver(hero);
      }

      if (heroIsVisible) {
        header.classList.add("in-hero");
      }

      if (s0) s0.style.transform = "none";
      if (s2) s2.style.transform = "none";
      if (s1) s1.classList.remove("hidden_spn");

      menuDataBox.classList.remove("active");
      document.body.classList.remove("menu-open");
    }
  });
});
/* ----------------------------- INFO TABS ----------------------------- */
document.querySelectorAll(".evemen-info-details-tab ul li").forEach(li => {
  li.addEventListener("click", () => {
    const content = li.querySelector(".evemen-info-details-tab-sub-content");
    if (!content) return;

    document
      .querySelectorAll(".evemen-info-details-tab ul li, .evemen-info-details-tab-sub-content")
      .forEach(el => el.classList.remove("active"));

    li.classList.add("active");
    content.classList.add("active");
  });
});

/* ----------------------------- ACCORDION SYSTEM 1 ----------------------------- */
(function () {
  function initAccordion(container) {
    const links = container.querySelectorAll("a");
    const contents = container.querySelectorAll(".accordion-content");

    function activate(i) {
      links.forEach((l, idx) => {
        l.classList.toggle("active", idx === i);
        contents[idx].style.display = idx === i ? "flex" : "none";
      });
    }

    if (links.length) activate(0);

    links.forEach((l, i) =>
      l.addEventListener("click", e => {
        e.preventDefault();
        activate(i);
      })
    );
  }

  document.querySelectorAll(".accordion-items").forEach(initAccordion);
})();

/* ----------------------------- ACCORDION SYSTEM 2 ----------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  function initAccordion() {
    const isMobile = window.innerWidth <= 950;

    document.querySelectorAll(".accordion-item-header").forEach(header => {
      const body = header.nextElementSibling;
      if (!body) return;

      header.classList.toggle("active", !isMobile);
      body.style.maxHeight = !isMobile ? body.scrollHeight + "px" : "0px";

      header.onclick = () => {
        header.classList.toggle("active");
        body.style.maxHeight = header.classList.contains("active")
          ? body.scrollHeight + "px"
          : "0px";
      };
    });
  }

  initAccordion();
  window.addEventListener("resize", initAccordion);
});

/* ----------------------------- ACCORDION SYSTEM 3 ----------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".m-accordion-item").forEach(item => {
    const h = item.querySelector(".m-accordion-item-header");
    const b = item.querySelector(".m-accordion-item-body");
    if (!h || !b) return;

    b.style.maxHeight = "0px";
    b.style.overflow = "hidden";

    h.addEventListener("click", () => {
      document.querySelectorAll(".m-accordion-item-body").forEach(el => {
        if (el !== b) el.style.maxHeight = "0px";
      });

      b.style.maxHeight =
        b.style.maxHeight === "0px" ? b.scrollHeight + "px" : "0px";
    });
  });
});

/* ----------------------------- SHOP ALL MENU ----------------------------- */
const allContent = document.querySelectorAll(".shop-all-right .right-content");
const listItems = document.querySelectorAll(
  ".shop-all-sub-menu-list ul li, .shop-all-menu-list ul li"
);

if (listItems.length) {
  let activeTarget = listItems[0].dataset.target;

  allContent.forEach(el => (el.style.display = "none"));
  document.getElementById(activeTarget).style.display = "block";

  listItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      activeTarget = item.dataset.target;
      allContent.forEach(el => (el.style.display = "none"));
      document.getElementById(activeTarget).style.display = "block";
    });
  });
}

/* ---------------------- LIVE SIZE MEASUREMENT SCRIPT ---------------------- */

(function () {

  function norm(v) {
    return String(v || "").trim().toUpperCase();
  }

  function readInchTable() {

    const table = document.querySelector('#inches table');

    if (!table) return {};

    const map = {};

    const headers = Array.from(
      table.querySelectorAll('thead th')
    ).map(h => norm(h.textContent));

    const rows = table.querySelectorAll('tbody tr');

    rows.forEach(row => {

      const cols = Array.from(
        row.querySelectorAll('td')
      ).map(td => td.textContent.trim());

      if (!cols.length) return;

      const size = norm(cols[0]);

      const obj = {};

      headers.forEach((h, i) => {
        obj[h] = cols[i] || "";
      });

      map[size] = obj;

    });

    return map;
  }

  function showOrHideRow(id, value) {

    const el = document.getElementById(id);

    if (!el) return;

    const row = el.closest(".live-row");

    if (!row) return;

    if (value && value !== "undefined" && value.trim() !== "") {
      row.style.display = "flex";
    } else {
      row.style.display = "none";
    }

    // HANDLE "/"
    const next = row.nextElementSibling;
    const prev = row.previousElementSibling;

    if (next && next.classList.contains("live-row-s")) {
      next.style.display =
        row.style.display === "none" ? "none" : "flex";
    }

    if (
      prev &&
      prev.classList.contains("live-row-s")
    ) {
      prev.style.display =
        row.style.display === "none" ? "none" : "flex";
    }

  }

  function updateBox(sizeRaw) {

    const size = norm(sizeRaw);

    const dataMap = readInchTable();

    const box = document.getElementById("live-size-box");

    if (!box) return;

    if (!dataMap[size]) {
      box.style.display = "none";
      return;
    }

    const d = dataMap[size];

    const fields = {

      "live-chest": d["CHEST"],

      "live-length":
        d["LENGTH"] ||
        d["FULL LENGTH"],

      "live-shoulder":
        d["SHOULDER"],

      "live-waist":
        d["WAIST"],

      "live-hip":
        d["HIP"] || d["HIPS"],

      "live-sleeve":
        d["SLEEVE"]

    };

    Object.keys(fields).forEach(id => {

      const el = document.getElementById(id);

      if (el) {
        el.textContent = fields[id]
          ? fields[id] + " Inch"
          : "";
      }

      showOrHideRow(id, fields[id]);

    });

    const liveSize = document.getElementById("live-size");

    if (liveSize) {
      liveSize.textContent = size;
    }

    box.style.display = "flex";

  }

  function updateFromSelected() {

    const checked = document.querySelector(
      'input[type="radio"]:checked'
    );

    if (checked) {
      updateBox(checked.value);
    }

  }

  document.addEventListener("change", function (e) {

    if (
      e.target.matches('input[type="radio"]')
    ) {

      setTimeout(() => {
        updateBox(e.target.value);
      }, 20);

    }

  });

  document.addEventListener("click", function (e) {

    if (
      e.target.tagName === "LABEL" &&
      e.target.htmlFor
    ) {

      const input = document.getElementById(
        e.target.htmlFor
      );

      if (
        input &&
        input.matches('input[type="radio"]')
      ) {

        setTimeout(() => {
          updateBox(input.value);
        }, 20);

      }

    }

  });

  document.addEventListener(
    "variant:changed",
    function (e) {

      const v =
        e.detail &&
        e.detail.variant;

      if (v?.option1) {
        updateBox(v.option1);
      }

    }
  );

  window.addEventListener("load", function () {

    setTimeout(updateFromSelected, 100);

    setTimeout(updateFromSelected, 500);

  });

  updateFromSelected();

})();


/* ============================================================
   FLIP TEXT
   – fully scoped, zero global leakage
   ============================================================ */
(function () {
  const flipText = document.getElementById('flip-text');
  if (!flipText) return;                          // guard: only run if element exists
 
  const words        = ['Free shipping on all orders over rs.2000', 'Easy and hassle-free returns on all orders', 'Cash on Delivery available across India'];
  let   currentIndex = 0;
  let   isAnimating  = false;
 
  function showWord(index) {
    if (isAnimating) return;
    isAnimating = true;
 
    const oldSpan = flipText.querySelector('span.active');
    if (oldSpan) {
      oldSpan.classList.remove('active');
      oldSpan.classList.add('exit');
      setTimeout(() => oldSpan.remove(), 300);
    }
 
    const span       = document.createElement('span');
    span.textContent = words[index];
    flipText.appendChild(span);
 
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        span.classList.add('active');
        setTimeout(() => (isAnimating = false), 300);
      });
    });
  }
 
  setInterval(() => {
    currentIndex = (currentIndex + 1) % words.length;
    showWord(currentIndex);
  }, 3000);
 
  showWord(currentIndex);
})();


document.addEventListener("DOMContentLoaded", function () {

  const stickyBar = document.querySelector(".sticky-atc");
  const trigger = document.querySelector(".bb-container");

  if (!stickyBar || !trigger) return;

  function checkPosition() {
    const rect = trigger.getBoundingClientRect();
    const triggerPoint = window.innerHeight * 0.2; // 20% from bottom

    // 👇 when element is about to go out (only 20% left)
    if (rect.bottom <= triggerPoint) {
      stickyBar.classList.add("show");
    } else {
      stickyBar.classList.remove("show");
    }
  }

  // Run on scroll
  window.addEventListener("scroll", checkPosition);

  // Run once on load
  checkPosition();
});


// /* ----------------------------- SIZE GUIDE ----------------------------- */
// window.showSizeGuide = id => {
//   document.querySelectorAll(".size2-option").forEach(t => t.classList.remove("active"));
//   document.querySelectorAll(".chart-container").forEach(c => c.classList.remove("active"));
//   document.querySelector(`.size2-option[onclick="showSizeGuide('${id}')"]`)?.classList.add("active");
//   document.getElementById(id)?.classList.add("active");
// };

// window.openSizeBox = () =>
//   document.querySelector(".size-2-body-container")?.classList.add("up");

// window.removeGuide = () =>
//   document.querySelector(".size-2-body-container")?.classList.remove("up");